import React, { memo, useState } from "react";
import classNames from "classnames/bind";
import styles from "../AuthModal.module.scss";

const cx = classNames.bind(styles);

const FormField = memo(({ 
  field, 
  value, 
  error, 
  touched, 
  onChange, 
  onBlur 
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = field.type === "password";

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={cx("form__field")}>
      <div className={cx("input__container", { "password-field": isPasswordField })}>
        <input
          type={isPasswordField ? (showPassword ? "text" : "password") : field.type}
          placeholder={field.placeholder}
          required={field.required}
          autoComplete="off"
          value={value || ""}
          onChange={(e) => onChange(field.name, e.target.value)}
          onBlur={() => onBlur(field.name)}
          className={cx({
            "field-error": touched && error,
          })}
        />
        {isPasswordField && (
          <button
            type="button"
            className={cx("password-toggle")}
            onClick={togglePasswordVisibility}
            aria-label={showPassword ? "Ẩn mật khẩu" : "Hiển thị mật khẩu"}
          >
            {showPassword ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2.458 12C3.732 7.943 7.523 5 12 5C16.477 5 20.268 7.943 21.542 12C20.268 16.057 16.477 19 12 19C7.523 19 3.732 16.057 2.458 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </button>
        )}
      </div>
      {touched && error && (
        <span className={cx("error__message")}>
          {error}
        </span>
      )}
    </div>
  );
});

FormField.displayName = "FormField";

export default FormField;
